import { z } from 'zod';
import { CAL_TAG_COLORS } from '../../events/cal-tag-colors.js';
import { requiredUuidString } from '../zod-helpers/index.js';
export const setCalTagColorInputSchema = z.object({
    id: requiredUuidString('Tag is required.', 'Invalid tag ID.'),
    color: z.enum(CAL_TAG_COLORS, { error: 'Choose a color from the palette.' }),
});
//# sourceMappingURL=set-cal-tag-color-input.js.map